/*
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2023-01-13 09:46:03
 * @LastEditors: dudedu
 * @LastEditTime: 2023-01-13 14:31:30
 */
import VueRouter from 'vue-router';
import Vue from 'vue';
import IndexView from '../views/IndexView.vue';
import WorkbenchView from '../views/workbench/IndexView.vue';

// 通过vue.use(插件)，安装插件
Vue.use(VueRouter);
// 创建路由对象
const routes = [
  {
    path: '/',
    name: 'home',
    component: IndexView,
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/login/IndexView.vue'),
  },
  {
    path: '/workbench',
    name: 'workbench',
    // route level code-splitting../views/monitor/index.vue
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: WorkbenchView,
    redirect: '/workbench/dashboard',
    children: [
      // 云环境管理
      // {
      //   path: 'cloudPlatform',
      //   name: 'cloudPlatform',
      //   component: () => import(/* webpackChunkName: "monitor" */ '../views/cloudPlatform/index.vue'),
      // },
      // 团队管理
      {
        path: 'team',
        name: 'team',
        component: () => import(/* webpackChunkName: "team" */ '../views/team/IndexView.vue'),
      },

      // 仪表盘管理
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/IndexView.vue'),
      },

      // 自定义集群管理
      {
        path: 'computingCluster',
        name: 'computingCluster',
        component: () => import(/* webpackChunkName: "resource" */ '../views/computingCluster/IndexView.vue'),
      },

      {
        path: 'customList',
        name: 'customList',
        component: () =>
          import(/* webpackChunkName: "customCluster" */ '../views/customCluster/customList/IndexView.vue'),
      },
      {
        path: 'customDetail',
        name: 'customDetail',
        component: () =>
          import(/* webpackChunkName: "customCluster" */ '../views/customCluster/customDetail/IndexView.vue'),
      },
      {
        path: 'logManagement',
        name: 'logManagement',
        component: () => import(/* webpackChunkName: "task" */ '../views/logManagement/IndexView.vue'),
      },
      {
        path: 'approval',
        name: 'approval',
        component: () => import(/* webpackChunkName: "task" */ '../views/approval/IndexView.vue'),
      },
      {
        path: 'backstage',
        name: 'backstage',
        component: () => import(/* webpackChunkName: "task" */ '../views/backstage/IndexView.vue'),
      },
      {
        path: 'configManagement',
        name: 'configManagement',
        component: () => import(/* webpackChunkName: "task" */ '../views/configManagement/IndexView.vue'),
      },
      {
        path: 'ipManagement',
        name: 'ipManagement',
        component: () => import(/* webpackChunkName: "task" */ '../views/ipManagement/IndexView.vue'),
      },
      {
        path: 'mirrorManagement',
        name: 'mirrorManagement',
        component: () => import(/* webpackChunkName: "task" */ '../views/mirrorManagement/IndexView.vue'),
      },
      {
        path: 'projectManagement',
        name: 'projectManagement',
        component: () => import(/* webpackChunkName: "task" */ '../views/projectManagement/IndexView.vue'),
      },
      {
        path: 'administrator',
        name: 'administrator',
        component: () => import(/* webpackChunkName: "task" */ '../views/administrator/IndexView.vue'),
      },
      {
        path: 'authorization',
        name: 'authorization',
        component: () => import(/* webpackChunkName: "task" */ '../views/authorization/IndexView.vue'),
      },
      {
        path: 'availableApplications',
        name: 'availableApplications',
        component: () => import(/* webpackChunkName: "task" */ '../views/availableApplications/IndexView.vue'),
      },
      {
        path: 'describeOperation',
        name: 'describeOperation',
        component: () => import(/* webpackChunkName: "task" */ '../views/describeOperation/IndexView.vue'),
      },
      {
        path: 'decodeWatermark',
        name: 'decodeWatermark',
        component: () => import('../views/decodeWatermark/IndexView.vue'),
      },
      {
        path: 'multiCloudCluster',
        name: 'multiCloudCluster',
        component: () => import(/* webpackChunkName: "task" */ '../views/multiCloudCluster/IndexView.vue'),
      },
      {
        path: 'multiCloudClusterDetail',
        name: 'multiCloudClusterDetail',
        component: () =>
          import(/* webpackChunkName: "task" */ '../views/multiCloudCluster/multiCloudClusterDetail/IndexView.vue'),
      },
    ],
  },
  {
    path: '/remoteDestop',
    name: 'remoteDestop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "remoteDestop" */ '../views/remoteDestop/IndexView.vue'),
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    redirect: '/notice',
    component: () => import('../views/helpCenter/IndexView.vue'),
    children: [
      {
        path: '/FAQ',
        name: 'FAQ',
        component: () => import('../views/helpCenter/faq/IndexView.vue'),
      },
      {
        path: '/introduction',
        name: 'introduction',
        component: () => import('../views/helpCenter/introduction/IndexView.vue'),
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('../views/helpCenter/notice/IndexView.vue'),
      },
      {
        path: '/messageInfo',
        name: 'messageInfo',
        component: () => import('../views/helpCenter/messageInfo/IndexView.vue'),
      },
    ],
  },
  // 维护页面
  {
    name: 'maintenance',
    path: '/maintenance',
    component: () => import('../views/maintenance/IndexView.vue'),
  },
  // 404
  {
    name: 'notFind',
    path: '/404',
    component: () => import('../components/404/index.vue'),
  },
  // 捕获所有未匹配的路由
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../components/404/index.vue'),
  },
];
const router = new VueRouter({
  // 配置URL和组价直接的映射关系
  routes,
  // history模式
  mode: 'history',
});
// 将router对象传入到vue实例中
export default router;
